import {
  type Contract,
  useAdminContracts,
  useCreateAdminContract,
  useDeleteAdminContract,
  useUpdateAdminContract,
} from "@features/contracts/api";
import { extractErrorMessage } from "@shared/extractErrorMessage";
import { App as AntdApp } from "antd";

export function useContractMutations(onSuccess: () => void) {
  const { message } = AntdApp.useApp();
  const contractsQuery = useAdminContracts();
  const createMut = useCreateAdminContract();
  const updateMut = useUpdateAdminContract();
  const deleteMut = useDeleteAdminContract();
  const onError = (err: unknown) => message.error(extractErrorMessage(err));

  return {
    contractsQuery,
    isPending: createMut.isPending || updateMut.isPending,
    create(payload: Omit<Contract, "id" | "created_at" | "updated_at">) {
      createMut.mutate(
        { data: payload as never },
        {
          onSuccess: () => {
            message.success("Договор создан");
            onSuccess();
            contractsQuery.refetch();
          },
          onError,
        },
      );
    },
    update(id: string, data: Partial<Contract>) {
      updateMut.mutate(
        { id, data: data as never },
        {
          onSuccess: () => {
            message.success("Сохранено");
            onSuccess();
            contractsQuery.refetch();
          },
          onError,
        },
      );
    },
    remove(id: string) {
      deleteMut.mutate(
        { id },
        {
          onSuccess: () => message.success("Удалено"),
          onError,
        },
      );
    },
  };
}
